import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/config/site";

export const WhatsAppFab = () => {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Falar no WhatsApp"
      className="fixed z-40 bottom-6 right-6 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_15px_40px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform animate-gentle-float"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
      <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-white ring-2 ring-[#25D366]" />
    </a>
  );
};
